import { PanelToolbar } from '../../components/panels/PanelToolbar';
import { LogTrackPanel } from '../../components/panels/LogTrackPanel';
import type { Track } from '../../components/panels/LogTrackPanel';

/** Planned vs. actual formation tops, the left half of the Operations Update tab. */
const TOPS = [
  { name: 'Seabed', planned: 95, actual: null },
  { name: 'Top I', planned: 693, actual: 699 },
  { name: 'Top J', planned: 1419, actual: 1408 },
  { name: 'Top K-Shale', planned: 1794, actual: 1822 },
  { name: 'K-30**', planned: 2353, actual: 2387 },
  { name: 'L-20*', planned: 2619, actual: 2482 },
  { name: 'L-60*', planned: 2732, actual: null },
  { name: 'L-80*', planned: 2887, actual: null },
  { name: 'FTD', planned: 3135, actual: null },
];

const MAX_DEPTH = 3300;
const CHART_H = 330;
const y = (d: number) => 22 + (d / MAX_DEPTH) * (CHART_H - 46);

const DIAGRAM_TRACKS: Track[] = [
  { title: 'SUBJECT', width: 96 },
  { title: 'WELL DIAGRAM', width: 190, scales: [{ name: 'MDDF / TVDSS', min: 'PLAN', max: 'ACTUAL' }] },
  { title: 'SUBJECT', width: 96 },
  {
    title: 'GAMMA RAY',
    width: 104,
    scales: [
      { name: 'Gamma Ray', min: '0', unit: 'api', max: '200' },
      { name: 'At-bit Gamma Ray', min: '0', unit: 'api', max: '200' },
    ],
  },
  {
    title: 'RESISTIVITY',
    width: 104,
    scales: [
      { name: 'Shallow Resistivity', min: '0.2', unit: 'ohmm', max: '200' },
      { name: 'Deep Resistivity', min: '0.2', unit: 'ohmm', max: '200' },
    ],
  },
  { title: 'DENSITY, NEUTRON & SONIC', width: 110 },
  { title: 'TG', width: 70, scales: [{ min: '0', unit: '%', max: '5' }] },
];

export function OperationsUpdate() {
  return (
    <div className="splitpane">
      <section className="panel" aria-label="Formation tops">
        <div className="topsbar">
          <select className="topsbar-select" defaultValue="Plot & Data (Both)" aria-label="Display">
            <option>Plot &amp; Data (Both)</option>
            <option>Plot only</option>
            <option>Data only</option>
          </select>
          <span className="topsbar-unit">MDDF</span>
        </div>

        <div className="topsplot">
          <svg viewBox={`0 0 560 ${CHART_H}`} role="img" aria-label="Planned against actual formation tops">
            <line x1="300" x2="300" y1="14" y2={CHART_H - 20} stroke="#d03b34" strokeWidth="1.2" />
            <line x1="316" x2="316" y1="14" y2={CHART_H - 20} stroke="#9aa4ab" strokeWidth="1" />

            {[0, 1000, 2000, 3000].map((d) => (
              <text key={d} x="322" y={y(d) + 3} className="tops-axis">
                {d}
              </text>
            ))}

            {TOPS.map((t) => (
              <g key={t.name}>
                <line x1="150" x2="300" y1={y(t.planned)} y2={y(t.planned)} stroke="#3a444c" strokeWidth="0.9" />
                <text x="146" y={y(t.planned) + 3.5} className="tops-label tops-label--plan">
                  {t.name}@ {t.planned}mMDDF
                </text>

                {t.actual !== null && (
                  <>
                    <line
                      x1="316"
                      x2="420"
                      y1={y(t.actual)}
                      y2={y(t.actual)}
                      stroke="#d03b34"
                      strokeWidth="0.9"
                    />
                    <text x="424" y={y(t.actual) + 3.5} className="tops-label tops-label--actual">
                      {t.name}@ {t.actual}mMDDF
                    </text>
                  </>
                )}
              </g>
            ))}
          </svg>

          <ul className="tops-legend">
            <li>
              <span className="dot dot--plan" /> Planned
            </li>
            <li>
              <span className="dot dot--actual" /> Actual
            </li>
          </ul>
        </div>
      </section>

      <section className="panel" aria-label="RT Ops Update">
        <PanelToolbar title="RT OPS UPDATE" accent options={['RT OPS UPDATE', 'WELL DIAGRAM']} />
        <LogTrackPanel tracks={DIAGRAM_TRACKS} depths={[3250, 3500]} minHeight={260} />
      </section>
    </div>
  );
}
